/* 活动业务模块 */
 ;
import _ from 'underscore';
import CONSTANT from '../constant/business';
import service from '../service/business';

export default {
  getCompanyAreaProductInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      return service.getCompanyAreaProductInfo(params).then(
        data => {
          commit(CONSTANT.BUSINESS_ENTERPRISE_PRODUCT_INFO_SUCCESS, data);
          resolve(data);
        },
        e => {
          commit(CONSTANT.BUSINESS_ENTERPRISE_PRODUCT_INFO_ERROR);
          reject(e);
        }
      );
    });
  }
};
